function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.88 12.7651C32.3445 14.2295 32.3445 16.6039 30.88 18.0683C29.4156 19.5327 27.0413 19.5327 25.5768 18.0683C24.1124 16.6039 24.1124 14.2295 25.5768 12.7651C27.0413 11.3006 29.4156 11.3006 30.88 12.7651Z",
  fill: "#D7D6E0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9806 21.8693C30.5621 19.5595 25.8948 19.5595 22.4762 21.8693C21.969 22.2118 21.666 22.7904 21.666 23.4175V26.6666H34.7908V23.4175C34.7908 22.7904 34.4878 22.2118 33.9806 21.8693Z",
  fill: "#D7D6E0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.881 12.7651C17.3455 14.2295 17.3455 16.6039 15.881 18.0683C14.4166 19.5327 12.0423 19.5327 10.5778 18.0683C9.11338 16.6039 9.11338 14.2295 10.5778 12.7651C12.0423 11.3006 14.4166 11.3006 15.881 12.7651Z",
  fill: "#D7D6E0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9816 21.8693C15.563 19.5595 10.8957 19.5595 7.47721 21.8693C6.97001 22.2118 6.66699 22.7904 6.66699 23.4175V26.6666H19.7918V23.4175C19.7918 22.7904 19.4887 22.2118 18.9816 21.8693Z",
  fill: "#D7D6E0"
});

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.fe1577d3.svg";
export { ForwardRef as ReactComponent };